import React, {Component, PropTypes} from 'react'

export class CardForm extends Component {

  static propTypes = {
    // onCharge(charge, token) => undefined
    onCharge: PropTypes.func,
    tableHost: PropTypes.string,
    stripeKey: PropTypes.string,
    profileId: PropTypes.string.isRequired
  }

  static defaultProps = {
    onCharge: () => {},
    stripeKey: 'pk_test_PJauI5nh8jeazkI9KmalheEp',
    tableHost: ''
  }

  state = {
    error: null
  }

  constructor (...args) {
    super(...args)
    if (!window.Stripe) {
      const stripejsTag = document.createElement('script')
      stripejsTag.setAttribute('src', 'https://js.stripe.com/v2/')
      document.head.appendChild(stripejsTag)
    }
  }

  componentDidMount () {
    window.Stripe.setPublishableKey(this.props.stripeKey)
  }

  makeChange (e) {
    e.preventDefault()
    const {profileId, onCharge, tableHost} = this.props
    const form = this._form
    window.Stripe.card.createToken(form, async (status, token) => {
      const res = await window.fetch(`${tableHost}/payments/api/charges/${profileId}`, {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          authentication: window.localStorage.getItem('ut'),
          'content-type': 'application/json'
        },
        body: JSON.stringify({token: token.id, amount: 1000, capture: false})
      })
      if (res.status >= 400) {
        this.setState({error: await res.text()})
      }
      onCharge(await res.json(), token)
    })
  }

  render () {
    return <div>
      {this.state.error && <span>{this.state.error}</span>}
      <form ref={r => { this._form = r }} onSubmit={::this.makeChange}>
        <div>
          <label>Card Number</label>
          <input type='text' size={20} data-stripe='number' />
          <label>CVC</label>
          <input type='text' size={4} data-stripe='cvc' />
        </div>
        <div>
          <label>Expiration Month</label>
          <input type='text' size={2} data-stripe='exp_month' />
          <label>Expiration Year</label>
          <input type='text' size={4} data-stripe='exp_year' />
        </div>
        <button>Add Card</button>
      </form>
    </div>
  }
}
